import {
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { RiSearch2Fill } from "react-icons/ri";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";

const SearchBar = ({ searchTerm, setSearchTerm, count }) => {
  return (
    <VStack w="100%" my="30px">
      <Flex alignItems="center" w="100%" justifyContent="space-between">
        <Text fontSize="24px" fontWeight="600" color="main_1">
          المواد
        </Text>

        <Flex alignItems="center">
          <LogoutMenu />
        </Flex>
      </Flex>

      <Text w="100%" fontSize="20px" textAlign="right">
        عدد المواد: {count}
      </Text>

      <HStack
        w="100%"
        justifyContent="space-between"
        mt="40px !important"
        p="10px"
        mb="-30px !important"
      >
        <InputGroup w={{ base: "100%", md: "400px" }}>
          <InputLeftElement
            pointerEvents="none"
            children={<RiSearch2Fill color="main_1" fontSize="20px" />}
          />
          <Input
            type="text"
            placeholder="ابحث عن المادة..."
            borderRadius="16px"
            bg="#f5f5f5"
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </HStack>
    </VStack>
  );
};

export default SearchBar;
